import { render, staticRenderFns } from "./VersionManage.vue?vue&type=template&id=a7dd8afc&scoped=true&"
import script from "./VersionManage.vue?vue&type=script&lang=js&"
export * from "./VersionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dd8afc",
  null
  
)

export default component.exports